import { CSSProperties, ElementType } from "react";

type Props = {
  text?: string;
  component?: ElementType;
  className?: string;
  style?: CSSProperties;
};

function TextView({ text, component: Component = "div", ...rest }: Props) {
  // TODO: sanitize html before injecting
  // eslint-disable-nextline react/no-danger
  return <Component dangerouslySetInnerHTML={{ __html: text }} {...rest} />;
}

export default TextView;
